
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CREATE_EDIT_SCHEDULED_ACTION_REQUEST,
    CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    createEditScheduledActionGetDetailResult,
    createEditScheduledActionResult,
    packagesDeletePackageResult,
} from 'Redux/actions';

function* getScheduledAction({ payload }) {
    try {
        let QUERY = `
            query getScheduledAction ($id: Int!) {
                result: getScheduledAction (id: $id) {
                    id
                    entityName
                    entityId
                    data
                    scheduleOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(createEditScheduledActionGetDetailResult(data?.result))
        else yield put(createEditScheduledActionGetDetailResult(null))

    } catch (exc) {
        yield put(createEditScheduledActionGetDetailResult(null))
        ExceptionManager(
            exc,
            "Modules/scheduledActions/views/components/createEditScheduledAction/redux/saga",
            "getScheduledAction",
        )
    }
}

function* updateScheduledAction({ payload }) {
    try {
         let QUERY = `
             mutation updateScheduledAction ($id: Int!, $scheduleOn: String!, $data: AWSJSON!, $entityName: String!, $entityId: Int!) {
                 result: updateScheduledAction (id: $id, scheduleOn: $scheduleOn, data: $data, entityName: $entityName, entityId: $entityId) {
                    id
                    scheduleOn
                    data
                 }
             }
         `;
        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

         if(data?.result) yield put(createEditScheduledActionResult(data.result))
         else yield put(createEditScheduledActionResult({ error: 'error-update-scheduled-actions' }))
 
    } catch (exc) {
        yield put(createEditScheduledActionResult({ error: exc?.error }))
        ExceptionManager(
            exc,
            "Modules/scheduledActions/views/components/createEditScheduledAction/redux/saga",
            "updateScheduledAction",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CREATE_EDIT_SCHEDULED_ACTION_REQUEST, updateScheduledAction);
    yield takeEvery(CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST, getScheduledAction);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}